/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  IStaticPageContentMethods,
  StaticPageContentService,
  GetBoxesService,
  IGetBoxesMethods,
  ICreatePayTxMethods,
  CreatePayTxService,
  IGetInvoicePdfTypeMethods,
  GetInvoicePdfService,
} from "./components";

export type PurchasedCostumePageAgent = IStaticPageContentMethods &
  IGetBoxesMethods &
  ICreatePayTxMethods &
  IGetInvoicePdfTypeMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new GetBoxesService(),
    new CreatePayTxService(),
    new GetInvoicePdfService(),
  ];
};

export const getAgent = () => {
  return createAgent<PurchasedCostumePageAgent>({
    plugins: getPlugins(),
  });
};
